var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loadingStatus.data)?_c('Dash-reach-body'):_vm._e(),_c('scroll-loader',{staticClass:"dash-loader",attrs:{"loader-method":()=> {},"loader-enable":!_vm.loadingStatus.data}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }